import MessageChat from './MessageChat'
import defapp from './defapp'

export default class CounterNotify { 

    static TYPE_RESULT_PRESENT = 0;
    static TYPE_RESULT_NOT_PRESENT = 1;
    static TYPE_RESULT_PRESENT_NOT_SELECTED = 2;

    sendNotifyRead(client,element,list_message, myId)
    {
        if (element.staff_id == myId)
        {
            let str_list_message = []
            list_message.map(function (k) { 
                if (k.type_user == defapp.TYPE_MESSAGE_RECEIVED)
                {
                    str_list_message.push(k.id)
                }
                
            })
            
            let msg = new MessageChat()
            let type = MessageChat.TYPE_READ_MESSAGE
            let prepareMessage = msg.prepareSendNotifyMessage(type, element.staff_id, "Notifica Read", "", element.id, str_list_message)
            client.sendMessage(prepareMessage)
        }
    }
    sendSingleNotifyRead(client, element,  myId) {
        
        if (element.staff_id == myId) {
            let str_list_message = []
            str_list_message.push(element.id)

            let msg = new MessageChat()
            let type = MessageChat.TYPE_READ_MESSAGE
            let prepareMessage = msg.prepareSendNotifyMessage(
                type,
                element.staff_id,
                "Notifica Read",
                "",
                element.chat_id,
                str_list_message,
                defapp.TYPE_MESSAGE_SENT
            );
            client.sendMessage(prepareMessage)
        }
    }
    sendClientNotifyRead(client, element, myId) { 
        if (element.user_id == myId) {
          let str_list_message = [];
          str_list_message.push(element.id);

          let msg = new MessageChat();
          let type = MessageChat.TYPE_READ_MESSAGE;
          let prepareMessage = msg.prepareSendNotifyMessage(
            type,
            element.staff_id,
            "Notifica Read",
            "",
            element.chat_id,
            str_list_message,
            defapp.TYPE_MESSAGE_RECEIVED
            );
            
          client.sendMessage(prepareMessage);
        }
    }
    sendPresainCaricoNotify(client,chat_selected,staffname,myId)
    {
        let msg = new MessageChat()
        let type = MessageChat.TYPE_INCARICO_MESSAGE;

        let prepareMessage = msg.prepareSendNotifyMessage(
            type,
            myId,
            "Ciao sono " + staffname + ", sono qui per aiutarti.",
            "",
            chat_selected.id,
            [],
            defapp.TYPE_MESSAGE_AUTOMATIC
        )
        client.sendMessage(prepareMessage)
    }
    sendRilasciaNotify(client, chat_selected, staffname, myId)
    {
        let msg = new MessageChat()
        let type = MessageChat.TYPE_RILASCIA_MESSAGE;

        let prepareMessage = msg.prepareSendNotifyMessage(
            type,
            myId,
            "Ciao sono " + staffname + ", sono qui per aiutarti.",
            "",
            chat_selected.id,
            [],
            defapp.TYPE_MESSAGE_AUTOMATIC
        )
        client.sendMessage(prepareMessage)
    }
    updateCounter(result, list_message, chat_selected, chat_assigned = null)
    {
        
        let message_list = result.messageId
        //chat_selected.counter_notify = chat_selected.counter_notify - message_list.length
        list_message.map(function (v) {
            v.date_read = result.date_read
        })
        if (chat_assigned != null)
        {
            chat_assigned.map(function (v) {
                if (v.id == chat_selected.id)
                {
                    if (v.counter_notify > 0)
                    {
                        v.counter_notify = v.counter_notify - message_list.length;
                    }
                }
            })
        }
    }
    updateClient(result, list_message)
    {
        list_message.map(function (v) {
            v.date_read = result.date_read
        })
    }
    controlMessageChat(message,chat_selected,chat_user_assigned,chat_not_assigned)
    {
        //SE IL MESSAGGIO FA PARTE DELLA CHAT SELEZIONATA RESTITUISCO 0 ALTRIMENTI RESTITUISCO 1 SE IL MESSAGGIO FA PARTE DELLE CHAT PRESENTI ALTRIMENTI
        //RESTITUISCO 2 PER REFRESHARE LA LISTA CHAT
       
        if(chat_selected == null)
        {
            return CounterNotify.TYPE_RESULT_NOT_PRESENT;
        }

        if (message.chat_id == chat_selected.id)
        {
            return CounterNotify.TYPE_RESULT_PRESENT;    
        } else {
            let trovato = false
            chat_user_assigned.map(function (v) {
                if (v.id == message.chat_id)
                {
                    v.counter_notify = v.counter_notify + 1 
                    trovato = true
                }
            })
            chat_not_assigned.map(function(v) {
              if (v.id == message.chat_id) {
                v.counter_notify = v.counter_notify + 1;
                trovato = true;
              }
            });

            if (trovato == false)
            {
                return CounterNotify.TYPE_RESULT_NOT_PRESENT;
            } else {
                return CounterNotify.TYPE_RESULT_PRESENT_NOT_SELECTED;
            }
        } 
            
    }
    sendNotifyChiusura(client,chat_selected)
    {
        let msg = new MessageChat();
        let type = MessageChat.TYPE_END_MESSAGE;
        let prepareMessage = msg.prepareSendNotifyMessage(
            type,
            chat_selected.staff_id,
            "Grazie per averci contattato. Siamo a disposizione per qualsiasi informazione anche al numero verde 800 987 787. A presto",
            chat_selected.user_id,
            chat_selected.id,
            [],
            defapp.TYPE_MESSAGE_SENT
        );

        client.sendMessage(prepareMessage);
    }
    sendNotifyChiusuraClient(client, chat_id, user_id) {
        let msg = new MessageChat();
        let type = MessageChat.TYPE_END_MESSAGE;
        let prepareMessage = msg.prepareSendNotifyMessage(
            type,
            0,
            "Il cliente ha abbandonato la chat",
            user_id,
            chat_id,
            [],
            defapp.TYPE_MESSAGE_RECEIVED
        );

        client.sendMessage(prepareMessage);
    }
    countNotificheNonLette(chat_assigned)
    {
        let totale = 0

        if (chat_assigned != null)
        {
            chat_assigned.map(function (v) {
                totale = totale + v.counter_notify
            });
        }

        return totale
    }
}